import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Route, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { iconsLibrary } from "../../../theme/constants";
import { EFooterStyleInput } from "../../data-types/footer.enum";
import { EStorageType } from "../../data-types/storage.enum";
import { CoworkingService } from "../../services/coworking.service";
import { LocalStorageService } from "../../services/local-storage.service";
import { CowingElementComponent } from "../shared/cowing-element/cowing-element.component";
import { CoworkingSpaceCardComponent } from "../shared/coworking-space-card/coworking-space-card.component";
import { showAlertAction } from "../../store/actions/alert.action";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { IAppState } from "../../store/state/app.state";
import { EButtonType } from "../../data-types/button.enum";

@Component({
  selector: "cowing-core-coworking-detail",
  templateUrl: "./coworking-detail.component.html",
  styleUrls: ["./coworking-detail.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class CoworkingDetailComponent implements OnInit {
  public EFooterStyleInput = EFooterStyleInput;
  public content: string = null;
  public coworkingInfo;
  public essentialsServices;
  public othersServices;
  public coworkingSpaces;
  public mediaObject = [];
  public EButtonType = EButtonType;
  @Input("coworkingId") coworkingId;
  @Input("previous") previous;
  @Input("platform") platform;
  @Output("goToNavigation") goToNavigation = new EventEmitter();
  sub;
  constructor(
    private _store: Store<IAppState>,
    private route: ActivatedRoute,
    private _router: Router,
    private translate: TranslateService
  ) {}
  async ngOnInit() {
    this._store.dispatch(showLoadingAction({}));
    try {
      const coworkingInfo = await CoworkingService.instance.getCoworkingInfo(
        this.coworkingId
      );
      const allServices = await CoworkingService.instance.getCoworkingServices(
        this.coworkingId
      );
      this.essentialsServices = allServices.filter(
        (services) => services.type === "Essentials"
      );
      this.othersServices = allServices.filter(
        (services) =>
          services.type === "Others" || services.type === "Free Covid"
      );
      const coworkingSpaces =
        await CoworkingService.instance.getCoworkingSpacesByCoworker(
          this.coworkingId
        );
      this.coworkingSpaces = coworkingSpaces;
      this.coworkingInfo = coworkingInfo;

      this.mediaObject.push({
        image: this.coworkingInfo.images["1"],
        thumbImage: this.coworkingInfo.images["1"],
      });
      this.mediaObject.push({
        image: this.coworkingInfo.images["2"],
        thumbImage: this.coworkingInfo.images["2"],
      });
      this.mediaObject.push({
        image: this.coworkingInfo.images["3"],
        thumbImage: this.coworkingInfo.images["3"],
      });
      this.mediaObject.push({
        image: this.coworkingInfo.images["4"],
        thumbImage: this.coworkingInfo.images["4"],
      });
      this.mediaObject.push({
        image: this.coworkingInfo.images["5"],
        thumbImage: this.coworkingInfo.images["5"],
      });

      if (this.coworkingInfo.video) {
        this.mediaObject.push({ video: this.coworkingInfo.video });
      }
      console.log("Object", this.mediaObject);
    } catch (e) {
      this._store.dispatch(
        showAlertAction({
          payload: {
            message:
              e.status === 401
                ? this.translate.instant("general.expired")
                : e.data.error,
            title: this.translate.instant("general.caution"),
            type: "error",
          },
        })
      );
    } finally {
      this._store.dispatch(closeLoadingAction({}));
    }
  }

  public goBooking() {
    this._router.navigate(["booking"], {
      queryParams: { coworkingId: this.coworkingId },
    });
  }

  public get getIconFav() {
    return `${iconsLibrary["heartFav"]}`;
  }

  public get getIconShare() {
    return `${iconsLibrary["shareActive"]}`;
  }

  public goToMap() {
    this.goToNavigation.emit({
      country: this.coworkingInfo.country,
      province: this.coworkingInfo.province,
      address: this.coworkingInfo.fiscal_address,
      latitude: this.coworkingInfo.latitude,
      longitude: this.coworkingInfo.longitude
    });
  }
}
